export default function CorrectIcon ({ wrapperClass }) {
  return(
    <svg className={wrapperClass} fill='currentColor'
      xmlns="http://www.w3.org/2000/svg"
      baseProfile="tiny"
      version="1.2"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      <path d="M16.972 6.251a1.999 1.999 0 00-2.72.777l-3.713 6.682-2.125-2.125a2 2 0 10-2.828 2.828l4 4a1.997 1.997 0 003.162-.442l5-9a2 2 0 00-.776-2.72z"></path>
    </svg>
  )
}